import React, { memo } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { Stack, Tooltip, Icon } from "investira.react.components";
import { EntidadeAvatar } from "../../molecules";

/**
 * Renderiza o componente Logo.
 *
 * @param {Object} props - Propriedades do componente.
 *
 * @description
 * Este componente realiza as seguintes operacoes:
 * 1. Recebe as propriedades necessarias para compor a interface
 * 2. Organiza os estados e callbacks usados durante a renderizacao
 * 3. Renderiza a experiencia visual do organismo
 *
 * @returns {JSX.Element|null} Elemento renderizado pelo componente.
 */

const Logo = memo(props => {
  const sEntidade = useSelector(store => store.entidade.current);
  const sEntidadeUpdateAt = useSelector(store => store.entidade.updateAt);

  // const isUpMd = useMediaQuery((theme) => theme.breakpoints.up("md"));
  const sessionCurrentEntidade = sessionStorage.getItem("current_entidade");
  const sessionCurrentEntidadeId = sessionStorage.getItem("current_entidade_id");
  if (props.isLoggedIn) {
    return <Stack>
        <Tooltip title={sEntidade.entidade}>
          <span>
            <EntidadeAvatar key={sEntidadeUpdateAt} alt={sessionCurrentEntidade || sEntidade.entidade} entidadeId={sessionCurrentEntidadeId || sEntidade.default_entidade_id} sx={{
            height: "24px",
            width: "24px",
            ...props.sx
          }} />
          </span>
        </Tooltip>
      </Stack>;
  }
  return <Link style={{
    display: "block",
    height: "32px"
  }} to={props.isLoggedIn ? "/dashboard" : "/"}>
      <Icon iconName="investira_icon" size={32} color="primary" />
    </Link>;
});
export default Logo;
